<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link
      href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"
      rel="stylesheet"
      id="bootstrap-css"
    />
    <script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
    <script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
    <title>Document</title>
  </head>
  <body>
    <div class="container">
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h1 style="text-align: center">
            Découvrez notre expertise en Neuropsychologie !
          </h1>
          <br />
        </div>
        <!-- <div class="col col-sm-6 col-md-6 col-lg-6 col-xl-6"></div> -->
        <hr />
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <br />
          <!-- <h3>De quoi s'agit-il ?</h3>
          <p>
            Passage des bilans cognitifs pour le dépistage
            <strong>des troubles de l'attention</strong>, de
            <strong>la mémoire</strong> et
            <strong>des fonctions exécutives</strong> auprès des
            <strong>enfants</strong> et des <strong>adultes </strong>
            <u>à partir de 6 ans</u>. <br /><br />
            La neuropsychologie est une branche de la psychologie qui étudie les
            liens entre le cerveau et le comportement. <br /><br />Nous évaluons
            les <strong>fonctions cognitives</strong> de nos patients à l'aide
            de <strong>tests</strong> pour détecter d'éventuels
            dysfonctionnements neurologiques. Les patients consultent, par
            exemple, pour des problèmes cognitifs liés à des traumatismes
            crâniens, des maladies neurologiques ou des troubles du
            développement. Le but est de diagnostiquer et de comprendre les
            bases neurologiques des symptômes observés afin d'élaborer un plan
            d'intervention. L'objectif est d'améliorer la qualité de vie globale
            du patient en atténuant les déficits identifiés.
            <br />
          </p> -->
          <p>
            Nous sommes spécialisés dans l'évaluation approfondie des capacités
            cognitives, y compris les capacités intellectuelles, offrant un
            service professionnel de dépistage des troubles de l'attention, de
            la mémoire et des fonctions exécutives, adapté aux enfants et aux
            adultes dès l'âge de 6 ans.
          </p>
          <br />
          <p>
            La neuropsychologie est une spécialité qui étudie la relation entre
            la science du cerveau et la compréhension du comportement humain.
            Notre service explore ces liens complexes pour offrir une
            compréhension globale et précise des vos attentes.
          </p>
          <br />
          <p>
            À travers nos évaluations spécialisées, nous identifions avec
            précision une gamme de troubles neurologiques potentiels, notamment
            ceux résultant de traumatismes crâniens, de maladies neurologiques
            ou de troubles du développement. Ces troubles peuvent se manifester
            par des difficultés d'attention et de concentration, des problèmes
            de mémoire, des troubles du langage ou des déficits dans les
            fonctions exécutives telles que la planification et l'organisation.
          </p>
          <br />
          <p>
            <strong>Bon à savoir :</strong> Si bien que nous utilisons les tests
            les plus reconnus au niveau international et d'avant garde en
            neuropsychologie,
            <u>les tests ne fournissent pas de diagnostic</u> à eux seuls.
            <u>Ils aident de façon objective</u> à repérer d'éventuels problèmes
            dans les capacités cognitives et comportementales du patient.
            Cependant, pour une évaluation complète,
            <u
              >l'expertise du neuropsychologue et l'histoire médicale du patient
              sont essentielles</u
            >. Ces informations aident à comprendre les résultats des tests dans
            le contexte des besoins du patient.
          </p>
          <br />
          <p><strong>Pour les enfants (à partir de 6 ans) :</strong></p>
          <br />
          <p>
            <strong>1.</strong> &nbsp;Trouble du déficit de l'attention avec ou
            sans hyperactivité (TDAH) : caractérisé par des difficultés
            d'attention soutenue, d'hyperactivité et d'impulsivité.<br />
            <strong>2.</strong> &nbsp;Troubles de l'apprentissage : difficultés
            spécifiques dans l'acquisition et l'utilisation de compétences
            académiques, comme la lecture, l'écriture ou les mathématiques.<br />
            <strong>3.</strong> &nbsp;Trouble du langage : difficultés dans
            l'expression et la compréhension du langage, pouvant inclure des
            troubles de la parole, du langage écrit ou du langage réceptif.<br />
            <strong>4.</strong> &nbsp;Troubles des fonctions exécutives :
            difficultés dans les processus cognitifs supérieurs tels que la
            planification, l'organisation, la flexibilité mentale et
            l'inhibition. <br />
            <strong>5.</strong> &nbsp;Troubles du développement : incluant le
            trouble du développement intellectuel et d'autres conditions qui
            affectent le développement neurologique typique.
            <br />
            <br />
            <strong>Pour les adultes :</strong>
            <br />
            <br />
            <strong>1.</strong> &nbsp;Trouble du déficit de l'attention avec ou
            sans hyperactivité (TDAH) : caractérisé par des difficultés
            d'attention soutenue, d'hyperactivité et d'impulsivité. <br />
            <strong>2.</strong> &nbsp;Trouble de la mémoire : difficultés à se
            souvenir d'informations précédemment apprises ou à former de
            nouveaux souvenirs.<br />
            <strong>3.</strong> &nbsp;Trouble du langage : difficultés dans
            l'expression et la compréhension du langage, pouvant inclure des
            troubles de la parole ou du langage réceptif.<br />
            <strong>4.</strong> &nbsp;Troubles des fonctions exécutives :
            difficultés dans les processus cognitifs supérieurs tels que la
            planification, l'organisation, la flexibilité mentale et
            l'inhibition.<br />
            <strong>5.</strong> &nbsp;Troubles neurodégénératifs : tels que le
            déclin cognitif liés à la maladie d'Alzheimer, la maladie de
            Parkinson et la sclérose en plaque, qui peuvent entraîner un déclin
            cognitif progressif.<br />
            <strong>6.</strong> &nbsp;Troubles psychiatriques comorbides : des
            conditions telles que la dépression, l'anxiété ou les troubles
            bipolaires, qui peuvent coexister avec des troubles neurologiques et
            affecter le fonctionnement cognitif.
          </p>
          <br />
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <br />
          <h3>
            Nos outils<span style="color: red; font-size: 30px">*</span> :
          </h3>
          <br />
          <br />
          <ul>
            <li>
              Evaluation du Coefficient Intellectuel (CI) : protocole WISC-V (<
              17 ans) et WAIS-IV (+17 ans)
            </li>
            <li>
              Evaluation du langage : CELF-5 (< 18 ans) ; Protocole spécifique
              pour les adultes
            </li>
            <li>
              Evaluation de la memoire : Test en Réalité Virtuel à partir de 12
              ans et MEM-IV (Adultes)
            </li>

            <li>
              Profil Attentionnel : Test en Réalité Virtuel à partir de 6 ans
            </li>
            <li>
              Fonctions exécutives : Test en Réalité Virtuel à partir de 8 ans
            </li>
          </ul>

          <br /><br />
          <p>
            <span style="color: red; font-size: 30px">*</span>Tous nos outils
            sont conformes aux exigences essentielles de la directive 93/42/CEE
            du Conseil, ainsi qu'à ses amendements découlant de la directive
            2007/47/CE, et aux normes essentielles de la norme EN ISO 13485
            concernant les systèmes de gestion de la qualité des produits de
            santé.
          </p>
        </div>
        <br />
        <hr />
      </div>
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <br />
          <h3>Déroulement des séances</h3>

          <br />
          <br />
          <div class="row">
            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header"><h5 class="card-title">1</h5></div>
                <div class="card-body">
                  <p class="card-text">
                    - Rencontrons-nous <br />- Anamnese <br />- Nouveau RDV pour
                    bilan Neuropsychologique
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header">
                  <h5 class="card-title">2</h5>
                </div>
                <div class="card-body">
                  <p class="card-text">
                    - Bilan Neuropsychologique <br />- Echanges autour des
                    résultats
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header"><h5 class="card-title">3</h5></div>
                <div class="card-body">
                  <p class="card-text">
                    Restitution d’un compte rendu détaillé par écrit
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3>Nos tarifs <span style="font-size: 30px; color: red">*</span></h3>
          <p>
            Consultation neuropsychologique &nbsp; &nbsp;
            <strong>60€</strong> <br />
            Bilan neuropsychologique &nbsp; &nbsp;
            <strong>350€</strong> <br />
          </p>
        </div>

        <p>
          <span style="font-size: 30px; color: red">*</span>
          Possibilité de paiement en plusieurs fois / tarifs sujets à
          modification.
        </p>
      </div>
    </div>
  </body>
</html>
